import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {DialogService} from '../../services/dialog.service';
import {UserSetting} from '../../models/user-setting';
import {SharedValueService} from '../../services/shared-value.service';

@Component({
  selector: 'app-face-icon-set',
  templateUrl: './face-icon-set.component.html',
  styleUrls: ['./face-icon-set.component.scss'],
  preserveWhitespaces: false
})
export class FaceIconSetComponent implements OnInit, OnChanges {
  @Input('iconSize') iconSize: number;
  @Input('reOpenParam') reOpenParam: any;
  faceIconDisplay = 'none';
  userSession: UserSetting;

  constructor(private dialogService: DialogService,
              private shared: SharedValueService) { }

  ngOnInit() {
    this.userSession = this.shared.getUserSession();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName === 'iconSize') {
        this.faceIconClassOptions();
      }
    }
  }
  faceIconClassOptions() {
    const classArr = [];
    classArr.push('face-icon-set-' + this.iconSize);
    return classArr;
  }

  onMouseEnter($event: any) {
    this.faceIconDisplay = 'block';
  }

  onMouseLeave($event: any) {
    this.faceIconDisplay = 'none';
  }

  onMouseClick($event: any) {
    const obj = {
      id: this.userSession.id,
      imageUrl: this.userSession.avatar,
      isAPICallError: false
    };
    this.dialogService.showCropperDialog('Avatar', obj,
      'showUserProfileModal', this.reOpenParam)
      .subscribe((result: any) => {
        // this.imageUrl = result.avatar ? result.avatar : null;
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/face-icon-set/face-icon-set.component.ts